import { Card } from 'primereact/card'
import { Outlet } from 'react-router-dom'

// TODO: Determine use case for PublicRoot, if any.
// NOTE: This is speculative architecture, which should probably be removed...
export default function PublicRoot() {
    return (
        <div>
            <Card title="Welcome to R&D public domain" />
            <Outlet />
        </div>
    )
}
